"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOccurredAt = exports.hasOwnProperty = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var hasOwnProperty = function (ctx, property) { return Object.prototype.hasOwnProperty.call(ctx, property); };
exports.hasOwnProperty = hasOwnProperty;
var getOccurredAt = function () { return new Date().toISOString(); };
exports.getOccurredAt = getOccurredAt;
exports.default = {};
//# sourceMappingURL=index.js.map